import {useMemo} from 'react';

import {Match} from '../types/ApplicantMatchesTypes';

import {useGetRequest} from '../../../../hooks/useGetRequest';
import {getApplicantMatches} from '../../../../lib/api/v1/applicant-dashboard';
import {SerializeTo} from '../../../../utils/serializer/serialize';


export const useApplicantMatches = (applicantId: string) => {
  const fetchMatches = useMemo(() => {
    return () => getApplicantMatches(applicantId);
  }, [applicantId]);

  const {data, error, loading} = useGetRequest(fetchMatches, SerializeTo.CamelCase<Match[]>);

  return {
    data,
    error,
    loading,
  };
};
